import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "lc_ttop"
};
const _hoisted_2 = {
  class: "lc-bsinfo"
};
const _hoisted_3 = {
  style: {
    "padding-bottom": "50px"
  }
};
const _hoisted_4 = {
  style: {
    "text-align": "center",
    "padding-bottom": "5px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LcButtons = _resolveComponent("LcButtons");
  const _component_lcBaseInfo = _resolveComponent("lcBaseInfo");
  const _component_lcggdytab = _resolveComponent("lcggdytab");
  const _component_lctinymce = _resolveComponent("lctinymce");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_table = _resolveComponent("el-table");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _component_el_main = _resolveComponent("el-main");
  return _openBlock(), _createBlock(_component_el_main, {
    class: "bg_white wrap_box lc_rw"
  }, {
    default: _withCtx(() => [_createVNode(_component_LcButtons, {
      ref: "lcButtons",
      type: 2,
      onBtsEmit: _cache[0] || (_cache[0] = $event => _ctx.btsEmit($event)),
      planStratTime: _ctx.data.baseInfo.plan_start_time_text,
      ids: _ctx.ids,
      projectName: _ctx.data.baseInfo.project_name,
      reviewerUserId: _ctx.data.baseInfo.reviewer_user_id,
      userId: _ctx.data.baseInfo.leader_user_id,
      msg: _ctx.data.baseInfo.msg,
      onGetPageInfo: _ctx.getPageInfo,
      deppgetPageInfo: _ctx.getPageInfo
    }, null, 8, ["planStratTime", "ids", "projectName", "reviewerUserId", "userId", "msg", "onGetPageInfo", "deppgetPageInfo"]), _createElementVNode("div", _hoisted_1, [_createVNode(_component_lcBaseInfo, {
      ref: "addBaseInfo",
      type: "taskInfo"
    }, null, 512)]), _createElementVNode("div", _hoisted_2, [_cache[4] || (_cache[4] = _createElementVNode("div", {
      class: "lc_title lc_ttop lc_add_ggdyb"
    }, "输出文件", -1)), _cache[5] || (_cache[5] = _createElementVNode("div", {
      class: "lc_title1"
    }, "规格定义表", -1)), _createVNode(_component_lcggdytab, {
      ggdyTableData: _ctx.data.ggdyTableData,
      "onUpdate:ggdyTableData": _cache[1] || (_cache[1] = $event => _ctx.data.ggdyTableData = $event),
      pageTag: "spxdmx",
      onOpenXDmxModel: _ctx.openXDmxModel,
      nobts: ['add', 'delet'],
      prtaskId: _ctx.ids
    }, null, 8, ["ggdyTableData", "onOpenXDmxModel", "prtaskId"]), _cache[6] || (_cache[6] = _createElementVNode("div", {
      class: "lc_title lc_ttop lc_add_ggdyb"
    }, "输出内容", -1)), _createElementVNode("div", {
      class: "l-button",
      onClick: _cache[2] || (_cache[2] = (...args) => _ctx.gospxdMx && _ctx.gospxdMx(...args))
    }, "下单明细"), _cache[7] || (_cache[7] = _createElementVNode("div", {
      class: "lc_ttop lc_bzt"
    }, "备注", -1)), _createElementVNode("div", _hoisted_3, [(_openBlock(), _createBlock(_component_lctinymce, {
      id: _ctx.data.id,
      ref: "editor",
      height: _ctx.data.height,
      "cur-value": "data.remark",
      onInput: _ctx.inputContent,
      key: _ctx.data.key
    }, null, 8, ["id", "height", "onInput"]))])]), _createVNode(_component_el_dialog, {
      title: "下单详情",
      modelValue: _ctx.data.xtshow,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.data.xtshow = $event),
      width: "550",
      style: {
        "padding-top": "0"
      }
    }, {
      default: _withCtx(() => [_createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.data.skuName), 1), _createElementVNode("div", null, [_createVNode(_component_el_table, {
        data: _ctx.data.noticeTableData,
        border: "",
        "max-height": 550,
        "show-summary": ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          prop: "depart",
          label: "部门",
          width: "250"
        }), _createVNode(_component_el_table_column, {
          prop: "num",
          label: "数量(pcs)",
          width: "200",
          align: "right"
        })]),
        _: 1
      }, 8, ["data"])])]),
      _: 1
    }, 8, ["modelValue"])]),
    _: 1
  });
}